/**
 * This big scary pipe interface allows for very nice type safety for piped functions
 *
 * It allows for the input type to differ from the output type
 * */
interface Pipe {
  <A, B>(fn1: (input: A) => B): (value: A) => B;
  <A, B, C>(fn1: (input: A) => B, fn2: (input: B) => C): (value: A) => C;
  <A, B, C, D>(
    fn1: (input: A) => B,
    fn2: (input: B) => C,
    fn3: (input: C) => D
  ): (value: A) => D;
  <A, B, C, D, E>(
    fn1: (input: A) => B,
    fn2: (input: B) => C,
    fn3: (input: C) => D,
    fn4: (input: D) => E
  ): (value: A) => E;
  <A, B, C, D, E, F>(
    fn1: (input: A) => B,
    fn2: (input: B) => C,
    fn3: (input: C) => D,
    fn4: (input: D) => E,
    fn5: (input: E) => F
  ): (value: A) => F;
  <A, B, C, D, E, F, G>(
    fn1: (input: A) => B,
    fn2: (input: B) => C,
    fn3: (input: C) => D,
    fn4: (input: D) => E,
    fn5: (input: E) => F,
    fn6: (input: F) => G
  ): (value: A) => G;
  <A, B, C, D, E, F, G, H>(
    fn1: (input: A) => B,
    fn2: (input: B) => C,
    fn3: (input: C) => D,
    fn4: (input: D) => E,
    fn5: (input: E) => F,
    fn6: (input: F) => G,
    fn7: (input: G) => H
  ): (value: A) => H;
  <A, B, C, D, E, F, G, H, I>(
    fn1: (input: A) => B,
    fn2: (input: B) => C,
    fn3: (input: C) => D,
    fn4: (input: D) => E,
    fn5: (input: E) => F,
    fn6: (input: F) => G,
    fn7: (input: G) => H,
    fn8: (input: H) => I
  ): (value: A) => I;
  <A, B, C, D, E, F, G, H, I, J>(
    fn1: (input: A) => B,
    fn2: (input: B) => C,
    fn3: (input: C) => D,
    fn4: (input: D) => E,
    fn5: (input: E) => F,
    fn6: (input: F) => G,
    fn7: (input: G) => H,
    fn8: (input: H) => I,
    fn9: (input: I) => J
  ): (value: A) => J;
}

export const pipe: Pipe =
  (...fns: CallableFunction[]) =>
  (x: any): unknown => {
    return fns.reduce((y, f) => f(y), x);
  };
